<template>
	<div class="IncidenciasListado">
		<h1>Incidencias</h1>
		<md-table-card class="w-100">
			<md-toolbar>
				<h1 class="md-title">Incidencias registradas</h1>
			</md-toolbar>
			<md-table>
				<md-table-header>
					<md-table-row>
						<md-table-head>Fecha</md-table-head>
						<md-table-head>Incidencia</md-table-head>
						<md-table-head>Punto</md-table-head>
						<md-table-head>Estatus</md-table-head>
						<md-table-head>Acciones</md-table-head>
					</md-table-row>
				</md-table-header>
				<md-table-body>
					<md-table-row v-for="i in incidencias" :key="i">
						<md-table-cell>{{i.fecha_ipu}}</md-table-cell>
						<md-table-cell>{{i.obs_ipu}}</md-table-cell>
						<md-table-cell>{{i.nombre_pun}}</md-table-cell>
						<md-table-cell>{{i.estatus_ipu.toUpperCase()}}</md-table-cell>
						<md-table-cell>
							<md-button class="md-icon-button md-raised md-accent" @click.native="abrirModalEstatusIncidencia(i)">
								<md-icon style="color:white">edit</md-icon>
							</md-button>
						</md-table-cell>
					</md-table-row>
				</md-table-body>
			</md-table>
		</md-table-card>
		<md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEstatusIncidencia">
			<md-dialog-content>
				<p>{{incidencia.obs_ipu}}</p>
				<md-input-container>
					<label for="estatus_ipu">Estatus</label>
					<md-select name="estatus_ipu" id="estatus_ipu" v-model="incidencia.estatus_ipu">
						<md-option value="pendiente">Pendiente</md-option>
						<md-option value="atendido">Atendida</md-option>
					</md-select>
				</md-input-container>
			</md-dialog-content>
			<md-dialog-actions>
				<md-button @click.native="cerraModal('modalEstatusIncidencia')">Cancelar</md-button>
				<md-button @click.native="guardarEstatus()">Cambiar estatus</md-button>
			</md-dialog-actions>
		</md-dialog>
	</div>
</template>

<script>
	import sha1 from 'js-sha1'
	import md5 from 'blueimp-md5'
	import Snackbar from 'node-snackbar'
	import $ from "jquery"
	import dt from "datatables.net"
	export default {
		name: 'IncidenciasListado',
		methods: {
			obtenerIncidencias(){
				this.$http.post('incidencias',{
					'token': this.$session.get('token')
				})
				.then(response => {
					if (response.status === 200 && 'incidencias' in response.body) {
						this.incidencias = response.body.incidencias
					}
				}, response => {
					Snackbar.show({
						text:'No se pudo establecer conexión con el servidor al obtener las incidencias.',
						actionText:'Cerrar',
						pos: 'top-right',
						showAction: false,
						backgroundColor:'#F44336',
						actionTextColor:'#FFF'
					});
				});
			},
			abrirModalEstatusIncidencia(i){
				this.incidencia = i;
				this.estatus_ipu_previo = i.estatus_ipu;
				this.abrirModal('modalEstatusIncidencia');
			},
			guardarEstatus(){
				this.$http.post('incidencias/estatus',{
					'token': this.$session.get('token'),
					'incidencia': this.incidencia.incidencia,
					'estatus': this.incidencia.estatus_ipu,
				})
				.then(response => {
					if (response.status === 200 && 'msg' in response.body) {
						Snackbar.show({
							text: response.body.msg,
							actionText: 'Cerrar',
							pos: 'top-right',
						});
					}else{
						this.incidencia.estatus_ipu = this.estatus_ipu_previo
						Snackbar.show({
							text: response.body.error,
							actionText:'Cerrar',
							pos: 'top-right',
							showAction: false,
							backgroundColor:'#F44336',
							actionTextColor:'#FFF'
						});
					}
				}, response => {
					Snackbar.show({
						text:'No se pudo establecer conexión con el servidor al obtener las incidencias.',
						actionText:'Cerrar',
						pos: 'top-right',
						showAction: false,
						backgroundColor:'#F44336',
						actionTextColor:'#FFF'
					});
				});
				this.cerraModal('modalEstatusIncidencia');
			},
			abrirModal(ref){
				this.$refs[ref].open();
			},
			cerraModal(ref){
				this.$refs[ref].close();
			}
		},

		beforeCreate(){
			if (!this.$session.exists()) {
				this.$router.push('/login')
			}
		},
		created(){
			this.obtenerIncidencias();
		},
		updated(){
			this.tabla = $('.md-table table').DataTable();
		},
		data(){
			return {
				msg: 'IncidenciasListado',
				incidencias: [],
				incidencia: {
					obs_ipu: null,
					estatus_ipu: null,
				},
				estatus_ipu_previo: null,
				tabla : null,
			}
		}
	}
</script>


// WEBPACK FOOTER //
// IncidenciasListado.vue?5ac655d0